module.exports = __webpack_public_path__ + "img/quest_title_robot.e453c917.svg";